// Pure, dependency-free CORS readiness derivation for
// RealBrandReadinessPage.js's live check.
//
// Kept in its own file with NO `@/` alias imports, specifically so it
// can be unit-tested via a plain relative import: this repo's Jest
// config does not resolve the `@/` webpack alias craco.config.js
// defines for the real app build (confirmed directly -- importing any
// page file that uses a `@/...` import fails jest-resolve with "Cannot
// find module"), which is exactly why every other page test in this
// repo uses static source-string assertions instead of actually
// importing/rendering a page component. This module has no such
// import, so it's the one piece of the new CORS logic that can be
// genuinely unit-tested rather than only source-asserted.

// `health` is GET /api/health's own parsed JSON body (or null on a
// failed request); `fetchFailed` distinguishes "the backend said no"
// from "we couldn't even ask it," which get two different honest
// statuses, never the same fallback.
export function deriveCorsCheck(health, fetchFailed) {
  if (fetchFailed || !health) {
    return {
      status: 'AMBER',
      evidence: 'Live check failed: could not reach GET /api/health to confirm CORS configuration right now -- treat as unverified, not confirmed safe. Retry, or verify backend/.env CORS_ORIGINS manually.',
    };
  }
  if (health.cors_configured) {
    return {
      status: 'GREEN',
      evidence: 'Live check (GET /api/health): CORS_ORIGINS is explicitly configured. server.py (AF-3.20.1, supersedes AF-3.17) also fails closed by default -- if this were ever unset, the backend would reject every cross-origin credentialed request outright, including from localhost, rather than falling back to a permissive default.',
    };
  }
  return {
    status: 'RED',
    evidence: 'Live check (GET /api/health): CORS_ORIGINS is not configured. server.py (AF-3.20.1) fails closed in this state -- every cross-origin credentialed request is rejected, including from localhost, so this is safe rather than silently permissive -- but a real frontend origin still needs to be configured before a real deployment can use this backend cross-origin.',
  };
}

export const CORS_CHECKING_STATE = {
  status: 'AMBER',
  evidence: 'Checking live CORS configuration (GET /api/health)…',
};
